import { render, staticRenderFns } from "./Role-data.vue?vue&type=template&id=47c7dc12"
import script from "./Role-data.vue?vue&type=script&lang=js"
export * from "./Role-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports